export const ERROR_USER_NOT_FOUND = 'User not found';
export const ERROR_USER_ALREADY_EXISTS = 'User already exists';

export const FILTER_TYPE_DESIGNER = 'designers';
export const FILTER_TYPE_CATEGORIES = 'category';
export const FILTER_TYPE_SIZES = 'sizes';
export const FILTER_TYPE_SEASONS = 'seasons';
export const FILTER_TYPE_CLEAR_ALL = 'clear all';
export const FILTER_TYPE_PRICE = 'price';
export const FILTER_TYPE_TOE_TYPES = 'toe_types';
export const FILTER_TYPE_HEEL_HEIGHTS = 'heel_heights';
export const FILTER_TYPE_SLEEVE_LENGTH = 'sleeve_length';
export const FILTER_TYPE_COLOR = 'color';

export const ACTION_INCREASE = 'increase';
export const ACTION_DECREASE = 'decrease';

export const MODAL_FILTERS = 'Filters Modal';
export const MODAL_PRIVACY_POLICY = 'Privacy Policy';
export const MODAL_TERMS_AND_CONDITIONS = 'Terms and Conditions';

export const NAV_MENU = 'Navigation Menu';

export const CONTEXT_SEARCH = 'search';
